import { render, staticRenderFns } from "./BankPage.vue?vue&type=template&id=444aae8d&scoped=true&"
import script from "./BankPage.vue?vue&type=script&lang=js&"
export * from "./BankPage.vue?vue&type=script&lang=js&"
import style0 from "./BankPage.vue?vue&type=style&index=0&id=444aae8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444aae8d",
  null
  
)

export default component.exports